import React from 'react';
import { Info } from 'lucide-react';

/**
 * Renders a beautiful empty state until enough input is provided to calculate.
 */
export const EmptyResult = ({ message = 'Fill in your details to see your result.' }) => (
  <div className="h-full flex flex-col items-center justify-center text-center py-10 sm:py-16" data-testid="empty-result">
    <div className="w-16 h-16 rounded-2xl bg-slate-800/60 border border-slate-700 flex items-center justify-center text-slate-500 mb-4">
      <Info className="w-7 h-7" aria-hidden="true" />
    </div>
    <p className="text-slate-400 text-sm sm:text-base max-w-xs">{message}</p>
  </div>
);

/**
 * Big result number card with optional category badge.
 */
export const PrimaryResult = ({ label, value, unit, accent = 'from-blue-500 to-cyan-500', category, testId }) => (
  <div className="text-center" data-testid={testId}>
    <p className="text-slate-400 text-sm uppercase tracking-wider mb-2">{label}</p>
    <div className="flex items-baseline justify-center gap-1.5">
      <span className={`text-5xl sm:text-6xl font-black bg-gradient-to-r ${accent} bg-clip-text text-transparent`}>{value}</span>
      {unit && <span className="text-slate-400 text-base sm:text-lg">{unit}</span>}
    </div>
    {category && (
      <div className={`inline-flex items-center gap-1.5 px-3 py-1 mt-4 ${category.border ? `border ${category.border}` : 'border border-slate-700'} rounded-full bg-slate-800/50`}>
        <span className={`w-2 h-2 rounded-full bg-current ${category.color}`} aria-hidden="true"></span>
        <span className={`text-sm font-semibold ${category.color}`}>{category.label}</span>
      </div>
    )}
  </div>
);

/**
 * Stat row for secondary results.
 */
export const StatRow = ({ label, value, unit, color = 'text-white', testId }) => (
  <div className="flex items-center justify-between py-3 border-b border-slate-800 last:border-0" data-testid={testId}>
    <span className="text-slate-400 text-sm">{label}</span>
    <span className={`font-semibold ${color} text-sm sm:text-base`}>
      {value}{unit && <span className="text-slate-500 ml-1 text-xs">{unit}</span>}
    </span>
  </div>
);
